import React from 'react';
import { Gamepad2 } from 'lucide-react';

export default function ShowcaseGames({ rig }) {
  const games = Array.isArray(rig.supported_games) ? rig.supported_games.filter(Boolean) : [];
  if (games.length === 0) return null;

  return (
    <section className="py-20 px-6 lg:px-10 border-t border-white/5 bg-[#111115]">
      <div className="max-w-7xl mx-auto">
        <p className="text-primary text-xs font-bold tracking-widest mb-3 flex items-center gap-2">
          <Gamepad2 className="w-3.5 h-3.5" /> SUPPORTED TITLES
        </p>
        <h2 className="text-white font-black text-3xl md:text-4xl uppercase mb-10">Ready To Race</h2>

        <div className="flex flex-wrap gap-3">
          {games.map((game) => (
            <span
              key={game}
              className="inline-flex items-center gap-2 bg-[#0d0d0f] border border-white/10 hover:border-primary/40 text-white/80 hover:text-white px-5 py-3 text-sm font-bold tracking-wide transition-colors"
            >
              <span className="w-1.5 h-1.5 bg-primary rounded-full" />
              {game}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}